import { CaseService } from "services";
import { List } from "immutable";
let actionPipeline = [];

export default () => next => action => {
    if (["FETCH_CASES"].includes(action.type)) {
        if (CaseService.serviceActive) {
            next(action);
        } else {
            actionPipeline.push(action);
        }
        return;
    } else if (action.type === "FETCHED_STAGES_LIST") {
        CaseService.init(
            new List(action.payload.stageList)
                .map(_ => ({
                    id: _.id,
                    name: _.stage_name
                }))
                .toMap()
                .mapEntries(([, v]) => [v.name, v])
        );
        next(action);
        actionPipeline.map(_ => next(_));
        actionPipeline = [];
        return;
    }
    next(action);
};
